import React, { useEffect } from 'react';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

export const useBodyScrollControl = (
  target: React.RefObject<HTMLElement>,
  isControlled: boolean,
) => {
  useEffect(() => {
    if (target.current == null) return;

    if (isControlled) {
      disableBodyScroll(target.current);
    } else {
      enableBodyScroll(target.current);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [target, isControlled]);
};
